exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".buttons[data-v-13f52b6d] {\n  margin-top: 270px;\n}", ""]);

// exports
